module.exports = __webpack_public_path__ + "static/media/teal.494e5d6e.png";